import type { MarketplaceAccount, MarketplaceChannel, MarketplaceConnectionState, MarketplaceCredential } from "../types/marketplaceAccount";

const channelEnabledTypes = new Set(["shopee", "lazada", "tiktok"]);

const toMillis = (value: unknown): number | undefined => {
  if (!value) return undefined;
  if (typeof (value as { toMillis?: () => number }).toMillis === "function") {
    return (value as { toMillis: () => number }).toMillis();
  }
  if (value instanceof Date) return value.getTime();
  if (typeof value === "object" && typeof (value as { seconds?: number }).seconds === "number") {
    return (value as { seconds: number }).seconds * 1000;
  }
  return undefined;
};

export const getCredentialState = (credential?: MarketplaceCredential): MarketplaceConnectionState => {
  if (!credential?.connectedAt && !credential?.accessTokenExpired && !credential?.expiredIn) return "disconnected";
  const expiresAt = toMillis(credential.accessTokenExpired || credential.expiredIn);
  return expiresAt && expiresAt <= Date.now() ? "reconnect" : "connected";
};

export const getAccountConnectionState = (account: MarketplaceAccount, channel: MarketplaceChannel) =>
  getCredentialState(account.credentials?.[channel]);

export const supportsMarketplaceChannelControls = (account: MarketplaceAccount) => channelEnabledTypes.has(account.type);

export const getAccountDisplayName = (account: MarketplaceAccount) =>
  account.name || account.searchKey || account.marketplaceShopId || "Unnamed shop";

export const getAccountLastUpdated = (account: MarketplaceAccount) => toMillis(account.updatedAt || account.createdAt);
